import React, { useEffect, useRef } from 'react';

export default function Verse({
    index,
    currentVerseIndex,
    toggleVerseVisibility,
    hiddenVerses,
    currentAudio,
    togglePlayVerse,
    splitVerseIntoWords,
    ayah,
    surahNumber,
    isPlayingAll
}) {
    const verseRef = useRef(null);

    useEffect(() => {
        // Scroll to verse if it's currently playing and not visible
        if (currentVerseIndex === index && verseRef.current) {
            const verseElement = verseRef.current;
            const rect = verseElement.getBoundingClientRect();

            // Check if verse is not visible in viewport
            if (
                rect.top < 0 ||
                rect.bottom > (window.innerHeight || document.documentElement.clientHeight)
            ) {
                verseElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }
        }
    }, [currentVerseIndex, index]);

    return (
        <div
            ref={verseRef}
            className={`verse ${currentVerseIndex === index ? 'playing' : ''}`}
            data-index={index}
            id={`ayah-${ayah.numberInSurah}`}
        >
            <button
                className="toggle-visibility"
                onClick={() => toggleVerseVisibility(index)}
            >
                {hiddenVerses[index] ? '👁️‍🗨️' : '👁️'}
            </button>

            <button
                className="play-button"
                onClick={() => togglePlayVerse(index)}
            >
                {currentVerseIndex === index && currentAudio.current && !currentAudio.current.paused ? '⏹' : '▶'}
            </button>

            <span className="verse-content">
                {splitVerseIntoWords(ayah.text, index, surahNumber)}
                <span className="verse-number">
                    <span>{ayah.numberInSurah}</span>
                </span>
            </span>


        </div>
    );
}